import { useState, Children, cloneElement } from 'react';
import { Container } from 'theme-ui';
import PropTypes from 'prop-types';

import { Accordion } from './Accordion';
import { themed } from './Accordions.theme';

export const Accordions = themed(
  ({
    theme,
    borderColor = 'text',
    children,
    iconColor = 'text',
    maxHeight = '350px', // upper range of how tall an open accordion panel could get
    minHeight = '60px', // height of accordion panel when closed
    textColor = 'text',
    oneOpenAtATime = true,
    defaultIndex = 0,
    inputRef,
    ...props
  }) => {
    const [openIndex, setOpenIndex] = useState(defaultIndex);

    return (
      <Container
        data-comp={Accordions.displayName}
        {...props}
        sx={{
          ...theme.accordions,
          borderColor,
          color: textColor,
          ...props.sx,
        }}
      >
        {Children.map(children, (child, index) => {
          const displayName =
            child?.props?.__EMOTION_TYPE_PLEASE_DO_NOT_USE__?.displayName ||
            child?.type?.displayName;

          if (displayName !== 'Accordion') return null;

          return cloneElement(child, {
            borderColor,
            iconColor,
            index,
            isOpen: index === openIndex,
            key: index,
            maxHeight,
            minHeight,
            setOpenIndex,
            oneOpenAtATime,
            textColor,
            ...child.props,
          });
        })}
      </Container>
    );
  }
);

Accordions.displayName = 'Accordions';
Accordions.Item = Accordion;

Accordions.propTypes = {
  textColor: PropTypes.string,
  borderColor: PropTypes.string,
  iconColor: PropTypes.string,
  minHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  oneOpenAtATime: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.element),
};
